import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { StripeCardElementChangeEvent } from '@stripe/stripe-js';
import * as creditCardStyles from 'src/styles/credit-card.module.scss';

interface StripeCardElementProps {
    onChange: (e: StripeCardElementChangeEvent) => void;
}

const StripeCardElement = ({ onChange }: StripeCardElementProps) => {
    const elementOptions = {
        style: {
            base: {
                color: '#313232',
                fontFamily: "'Muller', 'Helvetica Neue', Arial, Helvetica, sans-serif",
                fontSize: '16px',
                '::placeholder': {
                    color: '#CCCCCC',
                },
                textTransform: 'lowercase',
            },
            invalid: {
                color: '#EB5035',
                iconColor: '#EB5035',
            },
        },
    };

    return (
        <CardElement
            className={creditCardStyles.stripeCardElement}
            options={elementOptions}
            onChange={onChange}
        />
    );
};

export default StripeCardElement;
